import type { RoomDef } from '../../sim/types.ts';

/**
 * Room 6 — Cellar (brief §6).
 *
 * Two low Vine walls sit on the floor path, each with an item buried inside
 * it rather than under bare ground. Both are true walls-you-can-hop: a
 * single tile is well within jump reach, so nothing here blocks progress -
 * casting one open is a detour, not a requirement. That is the point: this
 * is the first room where a hidden item is a decision to make, not a thing
 * the player walks past unaware of (Room 1's Sprite is buried, but it sits
 * in bare ground with nothing marking the tile - see that room's own note).
 * A Vine wall reads as "something's in there" on sight.
 *
 * This is the Sprite's first appearance inside an actual block, and it
 * composes Room 3's destroy-to-reveal lesson defensively rather than to
 * cross a gap - the third use of cast/destroy so far, each for a different
 * reason.
 *
 * SCAFFOLD CONTENT (brief §14), same as Rooms 1-5.
 */
export const cellar: RoomDef = {
  id: '06-cellar',
  name: 'Cellar',
  map: [
    '################',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#..............#',
    '#.....~...~....#',
    '################',
    '################',
  ],
  spawn: { x: 3.5, y: 10 },
  portal: { tx: 14, ty: 9 },
  items: [
    { kind: 'lumen', tx: 5, ty: 9 },
    { kind: 'sprite', tx: 6, ty: 9, hidden: true },
    { kind: 'moonshard', tx: 10, ty: 9, hidden: true },
    { kind: 'moonseed', tx: 13, ty: 9 },
  ],
  chimera: [],
};
